import { MathpixMarkdown, MathpixLoader } from 'mathpix-markdown-it';
import { addListenerContextMenuEvents, removeListenerContextMenuEvents } from 'mathpix-markdown-it/lib/contex-menu';
import { loadSre } from 'mathpix-markdown-it/lib/sre/sre-browser';
import * as React from 'react';

const outMath = {
  include_svg: true,
  include_smiles: true,
  include_asciimath: true,
  include_latex: true,
  include_mathml: true,
  include_mathml_word: true,
};

const accessibility = {
  assistiveMml: true,
  sre: loadSre(),
};

// Prevent Setext-style headings: a line of dashes/equals immediately after text
// becomes an H2/H1 heading in Markdown. Insert a blank line before it so it
// renders as <hr> instead.
function preventSetextHeadings(text) {
  return text.replace(/([^\n])\n([-=]{2,}[ \t]*(?:\n|$))/g, '$1\n\n$2');
}

// eslint-disable-next-line react/prop-types
function MarkdownReader({ content }) {
  const [loading, setLoading] = React.useState(true);

  /** In order for the math to be accessibility, need to make sure that the sre module is loaded */
  React.useEffect(() => {
    accessibility.sre.engineReady().finally(() => {
      setLoading(false);
    });
  }, []);

  React.useEffect(() => {
    addListenerContextMenuEvents();
    return () => {
      removeListenerContextMenuEvents();
    };
  }, []);

  if (loading) {
    return <div className="App">Loading...</div>;
  }

  return (
    <div className="markdown-container m-chatMessage_content_text">
      <MathpixLoader>
        <MathpixMarkdown
          text={preventSetextHeadings(content)}
          outMath={outMath}
          accessibility={accessibility}
          htmlTags
          style={{
            padding: 0,
          }}
        />
      </MathpixLoader>
    </div>
  );
}

export default MarkdownReader;
